import React from 'react';

const Services = () => {
  return (
    <>
      <section className="page-header">
        <div className="container">
          <h1>Our Services</h1>
          <p>Comprehensive solutions for all your business needs</p>
        </div>
      </section>

      <section className="section-padding" style={{ padding: '30px 0' }}>
        <div className="container">
          <div className="section-header">
            <h2>What We Offer</h2>
            <p>End-to-end solutions across polymer trading, logistics, finance, and sustainability</p>
          </div>
        </div>
      </section>

      <section id="polymer" className="service-detail section-padding bg-light">
        <div className="container">
          <div className="service-content">
            <div className="service-text">
              <div className="service-badge">
                <i className="fas fa-cubes"></i>
                <span>Polymer Distribution</span>
              </div>
              <h2>Polymers - Domestic & International Prime Polymer</h2>
              <p className="lead">Leading supplier of high-quality polymer materials for various industries across India and globally.</p>
              
              <p>We specialize in sourcing, trading, and distributing a comprehensive range of polymer products including PP (Polypropylene), HDPE (High-Density Polyethylene), LDPE (Low-Density Polyethylene), LLDPE (Linear Low-Density Polyethylene), PVC (Polyvinyl Chloride), and various engineering plastics.</p>
              
              <h3>Our Polymer Range</h3>
              <div className="product-categories">
                {['PVC', 'HDPE', 'LDPE', 'LLDPE', 'PP', 'PET', 'ABS', 'Taita', 'EVAPC', 'GPPS', 'HIPS', 'EPS', 'Nylon 6', 'Other'].map((grade, index) => (
                  <div key={index} className="category-item">
                    <i className="fas fa-check-circle"></i>
                    <span>{grade}</span>
                  </div>
                ))}
              </div>
              
              <h3>Key Features</h3>
              <ul className="feature-list">
                <li><i className="fas fa-star"></i> Quality certified products from top manufacturers</li>
                <li><i className="fas fa-star"></i> Competitive pricing and bulk order discounts</li>
                <li><i className="fas fa-star"></i> Timely delivery across India and internationally</li>
                <li><i className="fas fa-star"></i> Technical support and product consultation</li>
                <li><i className="fas fa-star"></i> Flexible payment terms and credit facilities</li>
              </ul>
            </div>
            <div className="service-image">
              <img src="/assets/images/recycle/bsbapp6.webp" alt="Prime Polymer Materials" />
            </div>
          </div>
        </div>
      </section>

      <section id="logistics" className="service-detail section-padding">
        <div className="container">
          <div className="service-content reverse">
            <div className="service-image">
              <img src="/assets/images/Logistic/logistic.webp" alt="Truck Transportation & Logistics" />
            </div>
            <div className="service-text">
              <div className="service-badge">
                <i className="fas fa-truck-moving"></i>
                <span>Logistics Services</span>
              </div>
              <h2>Logistics - End-to-End Supply Chain Solutions</h2>
              <p className="lead">Comprehensive logistics services ensuring your cargo reaches its destination safely and on time.</p>
              
              <p>Our logistics division specializes in truck transportation services for delivering plastic polymer materials from supplier locations to buyer locations. We provide reliable, safe, and timely delivery services ensuring your polymer shipments reach their destination efficiently.</p>
              
              <h3>Our Logistics Services</h3>
              <div className="service-features-grid">
                {[
                  { icon: 'fa-truck', title: 'Truck Transportation', desc: 'Reliable truck services for delivering plastic polymer from supplier location to buyer location' },
                  { icon: 'fa-route', title: 'Route Optimization', desc: 'Efficient route planning to ensure fastest and most cost-effective delivery' },
                  { icon: 'fa-shield-alt', title: 'Safe Material Handling', desc: 'Expert handling and transportation of polymer materials ensuring product integrity' },
                  { icon: 'fa-clock', title: 'Timely Delivery', desc: 'On-time delivery commitment from supplier to buyer location' },
                  { icon: 'fa-map-marked-alt', title: 'Real-Time Tracking', desc: 'GPS-enabled tracking for complete shipment visibility from pickup to delivery' },
                  { icon: 'fa-truck-loading', title: 'Loading & Unloading', desc: 'Professional loading and unloading services at supplier and buyer locations' }
                ].map((feature, index) => (
                  <div key={index} className="service-feature-card">
                    <i className={`fas ${feature.icon}`}></i>
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="nbfc" className="service-detail section-padding bg-light">
        <div className="container">
          <div className="service-content">
            <div className="service-text">
              <div className="service-badge">
                <i className="fas fa-hand-holding-usd"></i>
                <span>Trade Finance Services</span>
              </div>
              <h2>Finance - NBFC Solutions for Business Growth</h2>
              <p className="lead">Flexible financing solutions to fuel your business expansion and working capital needs.</p>
              
              <p>As a registered Non-Banking Financial Company (NBFC), we provide and connect customized financial solutions including working capital finance, trade credit, invoice discounting, and business loans designed to support your growth objectives.</p>
              
              <h3>Our Financial Products</h3>
              <div className="finance-products">
                {[
                  {
                    icon: 'fa-coins',
                    title: 'Working Capital Finance',
                    desc: 'Short-term financing for day-to-day business operations and inventory management',
                    features: ['Flexible loan amounts', 'Quick disbursal (24-48 hours)', 'Competitive interest rates', 'Minimal documentation']
                  },
                  {
                    icon: 'fa-credit-card',
                    title: 'Trade Credit',
                    desc: 'Extended payment terms for your polymer purchases and trading activities',
                    features: ['30-90 days credit period', 'Credit limit based on business volume', 'No collateral for established clients', 'Automatic renewal options']
                  },
                  {
                    icon: 'fa-file-invoice-dollar',
                    title: 'Invoice Discounting',
                    desc: 'Improve cash flow by getting advance payment against your invoices',
                    features: ['Up to 80% advance against invoices', 'Quick approval process', 'No impact on customer relationships', 'Flexible repayment terms']
                  },
                  {
                    icon: 'fa-chart-line',
                    title: 'Business Loans',
                    desc: 'Term loans for business expansion, equipment purchase, and infrastructure development',
                    features: ['Loan amounts up to ₹5 Crore', 'Flexible tenure (1-5 years)', 'Competitive interest rates', 'Structured EMI options']
                  }
                ].map((product, index) => (
                  <div key={index} className="finance-card">
                    <div className="finance-icon">
                      <i className={`fas ${product.icon}`}></i>
                    </div>
                    <h4>{product.title}</h4>
                    <p>{product.desc}</p>
                    <ul>
                      {product.features.map((feature, fIndex) => (
                        <li key={fIndex}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
            <div className="service-image">
              <img src="/assets/images/polymers/nbfc.webp" alt="NBFC Financial Services" />
            </div>
          </div>
        </div>
      </section>

      <section id="recycle" className="service-detail section-padding">
        <div className="container">
          <div className="service-content reverse">
            <div className="service-image">
              <img src="/assets/images/recycle/product_recycle.webp" alt="Recycled Material Trading" />
            </div>
            <div className="service-text">
              <div className="service-badge">
                <i className="fas fa-recycle"></i>
                <span>Recycled Material Trading</span>
              </div>
              <h2>Recycle - Sustainable Polymer Solutions</h2>
              <p className="lead">Comprehensive trading platform for buying and selling high-quality recycled polymer materials.</p>
              
              <p>We specialize in trading recycled polymer materials including recycled PP, HDPE, LDPE, PVC, and other plastic grades. Our platform connects buyers and sellers of recycled materials, ensuring quality, competitive pricing, and reliable supply chain.</p>
              
              <h3>Our Recycled Material Trading Services</h3>
              <div className="recycling-services">
                {[
                  { icon: 'fa-shopping-cart', title: 'Recycled Material Sourcing', desc: 'Source high-quality recycled polymer materials from verified suppliers and processors' },
                  { icon: 'fa-handshake', title: 'Buyer-Seller Matching', desc: 'Connect buyers with sellers of recycled materials based on grade, quantity, and location' },
                  { icon: 'fa-chart-line', title: 'Market Pricing & Analysis', desc: 'Real-time pricing information and market analysis for recycled polymer materials' },
                  { icon: 'fa-certificate', title: 'Quality Verification', desc: 'Quality testing and certification services to ensure material specifications and standards' },
                  { icon: 'fa-truck', title: 'Logistics Support', desc: 'End-to-end logistics support for transportation of recycled materials from supplier to buyer' },
                  { icon: 'fa-file-contract', title: 'Trading Documentation', desc: 'Complete documentation support for recycled material trading transactions' }
                ].map((service, index) => (
                  <div key={index} className="recycle-item">
                    <i className={`fas ${service.icon}`}></i>
                    <h4>{service.title}</h4>
                    <p>{service.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section section-padding">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Experience Our Services?</h2>
            <p>Let us help you grow your business with our comprehensive solutions</p>
            <div className="cta-buttons">
              <a href="tel:+919825555470" className="btn btn-secondary">
                <i className="fas fa-phone"></i> Call Us Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;

